/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRef,
  LineItemRefOptional,
  LineItemRefMetaI,
  LineItemRefTrackedI,
} from "./line-item-ref";
import { LineItemRefTracked, LineItemRefMeta } from "./line-item-ref";

/**
 *
 * @export
 * @interface WithLineItemRef
 */
export interface WithLineItemRefOptional {
  /**
   *
   * @type {LineItemRef}
   * @memberof WithLineItemRef
   */
  lineItemId?: LineItemRefOptional;
}

export interface WithLineItemRef extends WithLineItemRefOptional {
  /**
   *
   * @type {LineItemRef}
   * @memberof WithLineItemRef
   */
  lineItemId?: LineItemRef;
}

export interface WithLineItemRefTrackedI {
  /**
   *
   * @type {LineItemRef}
   * @memberof WithLineItemRef
   */
  lineItemId?: LineItemRefTrackedI;
  lineItemIdIsSet: boolean;
}

transformDatesMap.set("WithLineItemRef", function (model: WithLineItemRef) {
  const transformDateslineItemId = transformDatesMap.get("LineItemRef");
  if (transformDateslineItemId && model.lineItemId) {
    transformDateslineItemId(model.lineItemId);
  }
});

export type WithLineItemRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  lineItemId: PropertyMeta<LineItemRefMetaI>;
}>;

export var WithLineItemRefMeta: WithLineItemRefMetaI =
  {} as WithLineItemRefMetaI;
WithLineItemRefMeta = typeMeta("WithLineItemRef", {
  lineItemId: propertyMeta("lineItemId", false, false, false, LineItemRefMeta),
});

const metaI = WithLineItemRefMeta;

registerMeta(() => {});

export class WithLineItemRefTracked implements WithLineItemRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  lineItemId__I?: LineItemRefTracked = undefined;
  lineItemIdIsSet: boolean = false;
  set lineItemId(v: undefined | LineItemRefTracked) {
    if (v !== undefined) {
      this.lineItemId__I = v;
      this.lineItemIdIsSet = true;
    } else {
      this.lineItemId__I = v || undefined;
      this.lineItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItemId() {
    return this.lineItemId__I;
  }
  constructor(config?: WithLineItemRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.lineItemId?.setIds();
  }
  assignFrom(
    config: WithLineItemRefOptional,
    options?: AssignOptions,
  ): WithLineItemRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.lineItemId &&
      this.lineItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.lineItemId = new LineItemRefTracked(config.lineItemId, options);
      if (optionsRequired.unassign) this.lineItemIdIsSet = false;
      else this.lineItemIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithLineItemRefTrackedI {
    const cloned = {} as WithLineItemRefTrackedI;
    if (
      this.lineItemIdIsSetDeep() &&
      this.lineItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemIdIsSet = true;
      cloned.lineItemId = this.lineItemId?.removeUnset(filter);
    } else {
      //cloned.lineItemIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithLineItemRefTrackedI {
    if (!this.lineItemIdApplyFilter(filter)) this.lineItemIdIsSet = false;
    this.lineItemId?.unassignAll(filter);

    return this;
  }
  lineItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithLineItemRefMeta.lineItemId,
      WithLineItemRefMeta,
      this.lineItemId,
      this,
    );
  }
  lineItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemIdIsSet && this.lineItemIdApplyFilter(filter)) return true;
    return this.lineItemId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.lineItemIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
